function BrowseOutline({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.55 17.565L3.96 18.975L5.75 17.175L4.34 15.765L2.55 17.565ZM10 18.475H12V21.475H10V18.475ZM0 9.47502H3V11.475H0V9.47502ZM12 2.52502V6.48502L13 7.06502C14.24 7.78502 15 9.10502 15 10.525C15 12.735 13.21 14.525 11 14.525C8.79 14.525 7 12.735 7 10.525C7 9.10502 7.77 7.78502 9 7.06502L10 6.48502V2.52502H12ZM14 0.525024H8V5.33502C6.21 6.37502 5 8.30502 5 10.525C5 13.835 7.69 16.525 11 16.525C14.31 16.525 17 13.835 17 10.525C17 8.30502 15.79 6.37502 14 5.33502V0.525024ZM19 9.47502H22V11.475H19V9.47502ZM16.24 17.185L18.03 18.985L19.44 17.575L17.64 15.785L16.24 17.185Z" fill=${`"${col}"`}/>
  </svg>
  `;

  return baseXml;
}

export default BrowseOutline;
